// extracted by mini-css-extract-plugin
module.exports = {"nextPage":"NextPage_nextPage__11pvJ","nextPage_alt":"NextPage_nextPage_alt__2loZP","nextPage__text":"NextPage_nextPage__text__1ze8p"};